"use client";

import React, { useEffect } from "react";
import Chatbot from "../components/Chatbot";
import Footer from "../components/common/Footer"

function About() {
  useEffect(() => {
    // Mobile menu toggle
    const menuBtn = document.getElementById("menu-btn");
    const mobileMenu = document.getElementById("mobile-menu");

    const handleMenuToggle = () => {
      if (mobileMenu) {
        mobileMenu.classList.toggle("hidden");
      }
    };

    if (menuBtn) {
      menuBtn.addEventListener("click", handleMenuToggle);
    }

    // Accordion functionality
    const toggleChildAccordion = (accordionId) => {
      const content = document.getElementById(`${accordionId}-content`);
      const arrowIcon = document.getElementById(`arrow-${accordionId}`);

      if (content) {
        content.classList.toggle("hidden");
      }
      if (arrowIcon) {
        arrowIcon.classList.toggle("rotate-180");
      }
    };

    // Attach toggle function to window for global access
    window.toggleChildAccordion = toggleChildAccordion;

    return () => {
      if (menuBtn) {
        menuBtn.removeEventListener("click", handleMenuToggle);
      }
      window.toggleChildAccordion = null;
    };
  }, []);

  return (
    <div>
      <Chatbot />

      <main className="flex overflow-hidden flex-col pb-11 bg-white">
        {/* Hero Section */}
        <header className="flex relative flex-col items-center self-stretch px-20 pb-36 w-full text-white min-h-[457px] max-md:px-5 max-md:pb-24 max-md:max-w-full">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/2380b75e399accef66dbd28b4055e1a0070fd63d?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
            alt="Hero Background"
            className="object-cover absolute inset-0 size-full"
          />


          <nav className="flex items-center justify-between w-full max-w-[1248px] px-5 py-3 relative mx-auto">
            {/* Logo */}
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/6f92263fde794fd91fb10442848bed84da061cb6?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
              alt="Company logo"
              className="w-[101px] object-contain"
            />

            {/* Mobile Menu Button */}
            <button id="menu-btn" className="block md:hidden text-white focus:outline-none">
              <svg
                className="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>

            {/* Navigation Wrapper */}
            <div id="menu" className="hidden md:flex relative items-center">
              {/* Background behind menu */}
              <div className="absolute inset-0 w-full h-full bg-white rounded-full"></div>

              {/* Menu Items */}
              <ul className="flex gap-10 px-8 py-3 text-indigo-950 text-base font-medium relative z-10">
                <li className="cursor-pointer">
                  <a href="/">Home</a>
                </li>
                <li className=" cursor-pointer">
                  <a href="/services">Services</a>
                </li>
                <li className=" cursor-pointer">
                  <a href="/projects">Projects</a>
                </li>
                <li className="font-bold cursor-pointer">
                  <a href="/about">About</a>
                </li>
              </ul>
            </div>

            {/* Contact Button */}
            <button className="px-5 py-2 bg-white text-indigo-950 font-bold rounded-full hidden md:block">
              <a href="/contact">Contact Us</a>
            </button>

            {/* Mobile Dropdown */}
            <div id="mobile-menu" className="absolute top-full left-0 w-full bg-white shadow-md hidden md:hidden">
              <ul className="flex flex-col items-center gap-4 py-4 text-indigo-950 font-medium">
                <li className="cursor-pointer">
                  <a href="/">Home</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/services">Services</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/projects">Projects</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/about">About</a>
                </li>
                <li>
                  <a href="/contact">
                    <button className="px-5 py-2 bg-white text-indigo-950 font-bold rounded-full">
                      Contact Us
                    </button>
                  </a>
                </li>
              </ul>
            </div>
          </nav>

          <p className="relative  mt-20 text-base text-center text-white w-[417px]">About us</p>
          <h1 className="relative  text-6xl font-semibold text-center text-white max-md:max-w-full max-md:text-4xl">
            Our Legacy of
            <br />
            Excellence
          </h1>
        </header>

        <section className="w-full max-w-6xl mx-auto mt-20 md:mt-28 px-4 md:px-0">
          <div className="flex flex-col md:flex-row gap-8">
            {/* Left Column (Image Grid) */}
            <div className="w-full md:w-[44%]">
              {/* Years of Experience Card */}
              <div className="flex flex-col md:flex-row gap-4">
                <div className="w-full md:w-1/2 bg-indigo-950 rounded-3xl p-8 text-white flex flex-col items-center justify-center aspect-square">
                  <p className="text-6xl md:text-7xl font-bold text-white ">08</p>
                  <p className="text-sm mt-2 text-white ">Years of Experience</p>
                </div>
                <div className="w-full md:w-1/2 rounded-3xl overflow-hidden aspect-square">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/32bd67a80704ac4c0eddb2d9d8f90c110904fa18?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                    alt="Experience Image"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Bottom Image Grid */}
              <div className="flex flex-col md:flex-row gap-4 mt-4">
                <div className="w-full md:w-1/2 rounded-3xl overflow-hidden aspect-square">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/5588bd714a16a9141495ca618fc2bf08219d9c9f?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                    alt="Company Image"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-full md:w-1/2 rounded-3xl overflow-hidden aspect-square">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/d6a0710534cd89f0c2fa062e66f07bd69303a72b?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                    alt="Company Image"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            {/* Right Column (Content) */}
            <div className="w-full md:w-[56%] flex flex-col justify-center">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                Tailored Electric Solutions for Homes & Industries!
              </h2>

              <p className="mt-6 text-gray-700 leading-relaxed">
                At Al-Abbas Electric & Solar Power, we excel in solar and electric solutions with
                <span className="font-medium text-black"> 8+ years</span> of expertise. Founded by
                <span className="font-medium text-black"> Syed Rameez Ali Shah</span>, we are committed to
                innovation, sustainability, and making clean energy accessible for a greener future.
              </p>

              {/* Features Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-8">
                {/* Feature 1 */}
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 rounded-full flex items-center justify-center">
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/9c7bf65f2e4f1228a6a1d0be3bad0fa9d72d3766?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                      alt="On-time Service Icon"
                      className="w-10 h-10"
                    />
                  </div>
                  <p className="mt-4 font-medium">Online at Services</p>
                </div>

                {/* Feature 2 */}
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 rounded-full flex items-center justify-center">
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/3d10021d151da955eaa35393163effe0c7b9a554?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                      alt="24/7 Service Icon"
                      className="w-10 h-10"
                    />
                  </div>
                  <p className="mt-4 font-medium">24/7 Hours Services</p>
                </div>

                {/* Feature 3 */}
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 rounded-full flex items-center justify-center">
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/79ff6c7c25229dc0cb11a4cdf848912c7be6c124?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                      alt="Certified Professionals Icon"
                      className="w-10 h-10"
                    />
                  </div>
                  <p className="mt-4 font-medium">Certified Professionals</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Vision and Mission Section */}
        <section className="w-full max-w-6xl mx-auto mt-20 md:mt-32 px-4 md:px-6">
          <div className="bg-blue-50 rounded-3xl p-8 md:p-14">
            {/* Vision & Mission Columns */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
              {/* Vision */}
              <div className="flex gap-4">
                <div className="shrink-0">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/3fdcf56e1dd65a2bff1da9e866c4d74d6f3f3ef4?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                    alt="Vision Icon"
                    className="w-16 h-16 rounded-full object-contain"
                  />
                </div>
                <div>
                  <h3 className="text-xl md:text-2xl font-semibold text-black">Vision</h3>
                  <p className="mt-2 text-gray-700">
                    Empowering Myanmar by unlocking its industrial and economic potential through access to safe,
                    reliable and affordable electricity.
                  </p>
                </div>
              </div>

              {/* Mission */}
              <div className="flex gap-4">
                <div className="shrink-0">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/4b5b958807105daf83f3bc4b08c3db6993df47eb?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                    alt="Mission Icon"
                    className="w-16 h-16 rounded-full object-contain"
                  />
                </div>
                <div>
                  <h3 className="text-xl md:text-2xl font-semibold text-black">Mission</h3>
                  <p className="mt-2 text-gray-700">
                    We aim to develop world-class electrical infrastructure by offering to our customers top quality
                    yet accessible products. We strive to always meet their expectations and do our best to exceed
                    them as much as possible.
                  </p>
                </div>
              </div>
            </div>

            {/* Stats Row */}
            <div className="mt-12 md:mt-16 flex flex-wrap justify-between gap-6 md:gap-10">
              {/* Successful Projects */}
              <div className="text-center min-w-[120px]">
                <p className="text-5xl md:text-7xl font-bold text-indigo-950">60+</p>
                <p className="text-sm mt-2">Successful Projects</p>
              </div>

              {/* Certified Staff */}
              <div className="text-center min-w-[120px]">
                <p className="text-5xl md:text-7xl font-bold text-indigo-950">35</p>
                <p className="text-sm mt-2">Certified Staff</p>
              </div>

              {/* Satisfied Clients */}
              <div className="text-center min-w-[120px]">
                <p className="text-5xl md:text-7xl font-bold text-indigo-950">50+</p>
                <p className="text-sm mt-2">Satisfied Clients</p>
              </div>

              {/* Awards Wins */}
              <div className="text-center min-w-[120px]">
                <p className="text-5xl md:text-7xl font-bold text-indigo-950">10</p>
                <p className="text-sm mt-2">Awards Wins</p>
              </div>
            </div>
          </div>
        </section>

        {/* Certifications Section */}
        <section className="w-full max-w-6xl mx-auto mt-20 md:mt-44 px-4 md:px-6">
          <div className="flex flex-col md:flex-row gap-8">
            {/* Certification Image (Left) */}
            <div className="w-full md:w-[45%] rounded-3xl overflow-hidden">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/ab0924b2a76feb7cd6123a4f117b6087f27d8c43?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                alt="Certification Image"
                className="w-full h-full object-cover aspect-square"
              />
            </div>

            {/* Content (Right) */}
            <div className="w-full md:w-[55%] flex flex-col justify-center">
              <div className="max-w-[600px]">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                  Verified & Trusted – Powering with Authenticity
                </h2>
                <p className="mt-4 md:mt-6 text-gray-700">
                  At Al Abbas Electric, trust is our foundation. We are proudly registered with leading legal bodies,
                  ensuring compliance, safety, and quality in every project. Our certifications reflect our
                  commitment to excellence and reliability in the electrical and solar industry.
                </p>
              </div>

              {/* Certification Logos */}
              <div className="flex flex-wrap gap-4 md:gap-6 mt-8 md:mt-10">
                <div className="w-[30%] min-w-[80px]">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/3f763283a44120e803828a5bbafad39e9dee103b?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                    alt="Certification Logo"
                    className="w-full h-auto object-contain"
                  />
                </div>
                <div className="w-[30%] min-w-[80px]">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/f5cc75826611b67b02117622b33a792727a46267?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                    alt="Certification Logo"
                    className="w-full h-auto object-contain"
                  />
                </div>
                <div className="w-[30%] min-w-[80px]">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/e1e1036abce6eb8af09a5acaacff54829f945342?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                    alt="Certification Logo"
                    className="w-full h-auto object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Trusted Venders Section */}
        <section className="w-full max-w-6xl mx-auto mt-20 md:mt-44 px-4 md:px-6">
          {/* Section Header */}
          <div className="text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Our Trusted Venders</h2>
            <p className="mt-3 md:mt-5 text-gray-600 max-w-[472px] mx-auto">
              We collaborate with industry-leading Venders to ensure quality and reliability in every project.
            </p>
          </div>
          <div className="self-end mt-44 mr-0 w-full max-w-[1184px] max-md:mt-10 max-md:mr-2.5 max-md:max-w-full">
            <div className="flex flex-col mb-20">
              <div className="flex gap-5 max-md:flex-col max-md:items-center"></div>

              <div id="solar-accordion" className="accordion-content">
                <div className="mt-10">
                  <div className="flex justify-between items-center">
                    <h3 className="text-2xl md:text-3xl font-bold">Solar Panels</h3>
                    <button
                      className="toggle-button p-[0.4rem] bg-blue-900 hover:bg-blue-800 transition-all flex items-center justify-center w-8 h-8 rounded-xl"
                      onClick={() => window.toggleChildAccordion("solar-panels")}
                    >
                      <i className="fa-solid fa-arrow-down rotate-180 text-white" id="arrow-solar-panels"></i>
                    </button>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-4">
                    <div className="space-y-8 md:space-y-12"></div>
                    <div className="space-y-8 md:space-y-12">
                      <p className="text-gray-700">
                        We partner with top solar brands to deliver high-quality, efficient, and reliable energy
                        solutions.
                      </p>
                    </div>
                  </div>
                  <div id="solar-panels-content" className="accordion-content">
                    <img
                      src="assets/img/about/Group 113.png"
                      alt="Solar Panels"
                      className="object-contain mt-4 w-full rounded-3xl aspect-[2.18] max-md:max-w-full"
                    />
                  </div>
                </div>

                <div className="mt-10">
                  <div className="flex justify-between items-center">
                    <h3 className="text-2xl md:text-3xl font-bold">Inverter On-Grid</h3>
                    <button
                      className="toggle-button p-[0.4rem] bg-blue-900 hover:bg-blue-800 transition-all flex items-center justify-center w-8 h-8 rounded-xl"
                      onClick={() => window.toggleChildAccordion("inverter-on-grid")}
                    >
                      <i className="fa-solid fa-arrow-up rotate-180 text-white" id="arrow-inverter-on-grid"></i>
                    </button>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-4">
                    <div className="space-y-8 md:space-y-12"></div>
                    <div className="space-y-8 md:space-y-12">
                      <p className="text-gray-700">
                        We provide top-quality on-grid inverters for efficient and reliable solar energy conversion.
                      </p>
                    </div>
                  </div>
                  <div id="inverter-on-grid-content" className="accordion-content hidden">
                    <img
                      src="assets/img/about/Group 112.png"
                      alt="Inverter On-Grid"
                      className="object-contain mt-4 w-full rounded-3xl aspect-[2.18] max-md:max-w-full"
                    />
                  </div>
                </div>

                <div className="mt-10">
                  <div className="flex justify-between items-center">
                    <h3 className="text-2xl md:text-3xl font-bold">Inverter Hybrid</h3>
                    <button
                      className="toggle-button p-[0.4rem] bg-blue-900 hover:bg-blue-800 transition-all flex items-center justify-center w-8 h-8 rounded-xl"
                      onClick={() => window.toggleChildAccordion("inverter-hybrid")}
                    >
                      <i className="fa-solid fa-arrow-up rotate-180 text-white" id="arrow-inverter-hybrid"></i>
                    </button>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-4">
                    <div className="space-y-8 md:space-y-12"></div>
                    <div className="space-y-8 md:space-y-12">
                      <p className="text-gray-700">
                        We offer high-performance hybrid inverters for seamless solar energy storage and usage.
                      </p>
                    </div>
                  </div>
                  <div id="inverter-hybrid-content" className="accordion-content hidden">
                    <img
                      src="assets/img/about/Group 114.png"
                      alt="Inverter Hybrid"
                      className="object-contain mt-4 w-full rounded-3xl aspect-[2.18] max-md:max-w-full"
                    />
                  </div>
                </div>

                <div className="mt-10">
                  <div className="flex justify-between items-center">
                    <h3 className="text-2xl md:text-3xl font-bold">Lithium Batteries</h3>
                    <button
                      className="toggle-button p-[0.4rem] bg-blue-900 hover:bg-blue-800 transition-all flex items-center justify-center w-8 h-8 rounded-xl"
                      onClick={() => window.toggleChildAccordion("lithium-batteries")}
                    >
                      <i className="fa-solid fa-arrow-up rotate-180 text-white" id="arrow-lithium-batteries"></i>
                    </button>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-4">
                    <div className="space-y-8 md:space-y-12"></div>
                    <div className="space-y-8 md:space-y-12">
                      <p className="text-gray-700">
                        Power up with reliable and long-lasting lithium batteries for efficient energy storage.
                      </p>
                    </div>
                  </div>
                  <div id="lithium-batteries-content" className="accordion-content hidden">
                    <img
                      src="assets/img/about/Group 115.png"
                      alt="Lithium Batteries"
                      className="object-contain mt-4 w-full rounded-3xl aspect-[2.18] max-md:max-w-full"
                    />
                  </div>
                </div>

                <div className="mt-10">
                  <div className="flex justify-between items-center">
                    <h3 className="text-2xl md:text-3xl font-bold">Tubular Batteries</h3>
                    <button
                      className="toggle-button p-[0.4rem] bg-blue-900 hover:bg-blue-800 transition-all flex items-center justify-center w-8 h-8 rounded-xl"
                      onClick={() => window.toggleChildAccordion("tubular-batteries")}
                    >
                      <i className="fa-solid fa-arrow-up rotate-180 text-white" id="arrow-tubular-batteries"></i>
                    </button>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-4">
                    <div className="space-y-8 md:space-y-12"></div>
                    <div className="space-y-8 md:space-y-12">
                      <p className="text-gray-700">
                        Power up with reliable and long-lasting tubular batteries for efficient energy storage.
                      </p>
                    </div>
                  </div>
                  <div id="tubular-batteries-content" className="accordion-content hidden">
                    <img
                      src="assets/img/about/Group 116.png"
                      alt="Tubular Batteries"
                      className="object-contain mt-4 w-full rounded-3xl aspect-[2.18] max-md:max-w-full"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="power-up-container">
          <div className="power-up-content">
            <h1 className="font-medium">Let's Power Up Together!</h1>
            <p className="text-[17px] my-5 text-gray-600">
              Have questions or need expert electrical and solar solutions?
              <br />
              Our team is ready to assist you. Get in touch today!
            </p>

            <div className="power-up-form">
              <input type="text" placeholder="Enter Your Name" />
              <input type="text" placeholder="Write Your Phone" />
              <select>
                <option value="">Select Service</option>
                <option>Solar Solutions</option>
                <option>Street Pole</option>
                <option>Electrical Services</option>
              </select>
              <button>Get Free Quotation</button>
            </div>
          </div>

          <div className="power-up-image">
            <img src="assets/img/man.png" alt="Man with headphones" />
          </div>
        </div>
        {/* Footer */}
        <Footer />
      </main>
    </div>
  );
}

export default About;